import { render, staticRenderFns } from "./EmojiList.vue?vue&type=template&id=7870b30a&scoped=true&"
import script from "./EmojiList.vue?vue&type=script&lang=js&"
export * from "./EmojiList.vue?vue&type=script&lang=js&"
import style0 from "./EmojiList.vue?vue&type=style&index=0&id=7870b30a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870b30a",
  null
  
)

export default component.exports